<template>
    <div class="selector-list">
        <div
            @click="onSelect(item.id)"
            v-for=" (item,index) in data"
            :key="index"
            class="each-select"
        >
            <p
                :class="[
                    Number(item.id) === Number(current) ? 'active' : ''
                ]"
            >{{item.value}}</p>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      current: ''
    }
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    initialIndex: [String, Number]
  },
  created () {
    if (this.initialIndex) {
      this.current = this.initialIndex
    }
  },
  methods: {
    onSelect: function (key) {
      console.log(key)
      this.current = key
      this.$emit('onSelectEmit', key)
    }
  }
}
</script>

<style lang="scss" scoped>
.selector-list {
    display: flex;
    width: 1000px;
    justify-content: space-between;
    cursor: pointer;
    text-align: center;
    .each-select:hover {
        p {
            font-size: 18px;
            color: rgba(0, 82, 188, 1);
        }
    }
    .each-select {
        display: flex;
        justify-content: space-between;
        text-align: center;
        position: relative;
        div:nth-child(1) {
            height: 22px;
            border-left: 1px solid #e5e5e5;
            margin: 0 30px;
        }
        p {
            font-size: 16px;
            color: rgba(0, 0, 0, 1);
            line-height: 19px;
            transition: all 0.2s;
            padding-bottom: 5px;
            border-bottom: 2px solid white;
        }
        .active {
            font-size: 18px;
            color: rgba(0, 82, 188, 1);
            border-bottom: 2px solid rgba(0, 82, 188, 1);
            border-radius: 2px;
        }
    }
    .each-select + .each-select {
        &::before {
            content: "";
            width: 1px;
            height: 22px;
            left: -20px;
            background: #e5e5e5;
            position: absolute;
        }
    }
}
</style>
